import React, { Component } from 'react';

class MealProgress extends Component {
  handleClick(index, id) {
    this.props.onStepChange(index);
    this.props.scrollToStep(id);
  }

  render() {
    var steps = this.props.steps || [];
    var activeStep = this.props.activeStep;

    return (
      <div className="meal-progress">
        {steps.map(function(step, index) {
          var isCurrent = activeStep === index;
          var isCompleted = activeStep > index;

          return (
            <div
              className="progress-step"
              key={step.id}
            >
              <button
                type="button"
                className={
                  'step-circle ' +
                  (isCurrent ? 'active ' : '') +
                  (isCompleted ? 'completed' : '')
                }
                onClick={function() {
                  this.handleClick(
                    index,
                    step.id
                  );
                }.bind(this)}
              >
                {step.number}
              </button>

              <span
                className={
                  'step-label ' +
                  (activeStep === index + 1
                    ? 'active-label'
                    : '')
                }
              >
                {step.label}
              </span>

              {index !== steps.length - 1 && (
                <div
                  className={
                    'step-line ' +
                    (activeStep > index
                      ? 'completed'
                      : '')
                  }
                />
              )}
            </div>
          );
        }.bind(this))}
      </div>
    );
  }
}

export default MealProgress;
